var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"56","cy":"56","r":"53.5","stroke":"white","strokeWidth":"5","key":0}),React.createElement("path",{"d":"M85 52.5359C87.6667 54.0755 87.6667 57.9245 85 59.4641L44.5 82.8468C41.8333 84.3864 38.5 82.4619 38.5 79.3827L38.5 32.6173C38.5 29.5381 41.8333 27.6136 44.5 29.1532L85 52.5359Z","fill":"white","key":1})]);
}

PlayIcon.defaultProps = {"width":"112","height":"112","viewBox":"0 0 112 112","fill":"none"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
